import { Icon, IconButton } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import TopBar from 'components/lib/navigation/TopBar';
import TopBarCenter from 'components/lib/navigation/TopBarCenter';
import TopBarLeft from 'components/lib/navigation/TopBarLeft';
import TopBarRight from 'components/lib/navigation/TopBarRight';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps, Switch, withRouter } from 'react-router';
import { compose } from 'redux';
import { setUserDataAction, setUserIsSignedOutAction } from '../auth/actions';
import Authentication from '../auth/components/Authentication';
import { AuthState, IAuthState } from '../auth/model';
import NavigationDrawer from '../components/NavigationDrawer';
import firebaseApp from '../firebase';
import { setProfile, setPublisher } from '../profile/actions';
import { IProfileData, IProfilePublisherData } from '../profile/model';
import { loadCheckouts, loadProfile } from '../profile/services';
import { DASHBOARD_PATH, MY_READING_PATH } from '../route-constants';
import Dashboard from '../routes/Dashboard';
import MyReading from '../routes/MyReading';

interface IStateProps {
  auth: IAuthState;
}

interface IStoreFunction {
  loadProfile: () => {};
  loadCheckouts: (uidParam?: string) => {};
  setUserDataAction: () => {};
  setProfile: (profileData: IProfileData) => {};
  setPublisher: (profileData: IProfilePublisherData) => {};
  setUserIsSignedOutAction: () => {};
}

type allProps = IStateProps & IStoreFunction & RouteProps;

interface IAppContainerState {
  drawerOpen: boolean;
}

class AppContainer extends React.Component<allProps> {
  public readonly state: IAppContainerState;

  constructor(props: any) {
    super(props);
    this.state = {
      drawerOpen: false,
    };
    this.listenAuth();
  }

  public render() {
    const { auth } = this.props;

    switch (auth.authState) {
      case AuthState.Unknown:
        return <LinearProgress />;

      case AuthState.NotAuthenticated:
        // Show login Page
        return <Authentication />;

      case AuthState.Authenticated:
        if (this.shouldRedirectToHome()) {
          return <Redirect to={DASHBOARD_PATH} />;
        }
        return (
          <React.Fragment>
            <TopBar color="light">
              <TopBarLeft>
                <IconButton onClick={this.toggleDrawer()}>
                  <Icon>menu</Icon>
                </IconButton>
              </TopBarLeft>

              <TopBarCenter>{null}</TopBarCenter>

              <TopBarRight>{null}</TopBarRight>
            </TopBar>

            <NavigationDrawer
              onClose={this.toggleDrawer(false)}
              drawerOpen={this.state.drawerOpen}
            />

            <Switch>
              <Route path={DASHBOARD_PATH} component={Dashboard} />
              <Route path={MY_READING_PATH} component={MyReading} />
            </Switch>
          </React.Fragment>
        );
    }
  }

  private toggleDrawer = (toggleState: boolean | undefined = undefined) => () => {
    let newOpenState: boolean = !this.state.drawerOpen;
    if (toggleState !== undefined) {
      newOpenState = toggleState;
    }
    this.setState({
      drawerOpen: newOpenState,
    });
  };

  private shouldRedirectToHome() {
    const { location } = this.props;
    return (location && location.pathname === '/');
  }

  private listenAuth() {
    firebaseApp.auth().onAuthStateChanged((user: any) => {
      if (user && user.uid) {
        // User is authenticated
        this.props.setUserDataAction();

        this.props.setProfile({
          uid: user.uid,
        });

        this.props.loadCheckouts(user.uid);
        this.props.loadProfile();
      } else {
        // User is not authenticated
        this.props.setUserIsSignedOutAction();
      }
    });
  }
}

const mapStateToProps = (state: { auth: IAuthState }): IStateProps => ({
  auth: state.auth,
});

const enhance = compose(
  withRouter,
  connect(
    mapStateToProps,
    {
      loadCheckouts,
      loadProfile,
      setProfile,
      setPublisher,
      setUserDataAction,
      setUserIsSignedOutAction,
    }
  )
);

export default enhance(AppContainer);



// WEBPACK FOOTER //
// ./src/containers/AppContainer.tsx